import React from 'react';
import { Alert } from 'react-bootstrap';
import ConfirmationModal from '@enerex/unified-ui-react/ConfirmationModal';
import Div from 'components/Div';
import Text from 'components/Text';
import SearchableSelect, { Option } from 'components/SearchableSelect';
import ConfirmButton from 'components/ConfirmButton';
import { ICompany } from '../types';

interface AddUpdateParentModalProps {
    show: boolean;
    mode: 'add' | 'update';
    company: ICompany;
    selectedParent: Option | null;
    parentError: string;
    onClose: () => void;
    onParentChange: (option: Option | null) => void;
    onSave: () => Promise<void>;
    onRemove: () => Promise<void>;
    loadParentOptions: (inputValue: string) => Promise<Option[]>;
}

const AddUpdateParentModal: React.FC<AddUpdateParentModalProps> = ({
    show,
    mode,
    company,
    selectedParent,
    parentError,
    onClose,
    onParentChange,
    onSave,
    onRemove,
    loadParentOptions,
}) => {
    const modalTitle = mode === 'add' ? 'Add Parent Company' : 'Update Parent Company';

    return (
        <ConfirmationModal
            dialogClassName="modal-md"
            centered
            show={show}
            onHide={onClose}
            title={modalTitle}
            confirmButtonLabel={mode === 'add' ? 'Add parent' : 'Update parent'}
            onConfirm={() => {
                if (!selectedParent) return;
                onSave();
            }}
        >
                {parentError && (
                    <Alert variant="danger">
                        {parentError}
                    </Alert>
                )}
                <Div className="mb-2">
                    <Text variant="plain" className="mb-1">
                        Select parent company
                    </Text>
                    <SearchableSelect
                        loadOptions={loadParentOptions}
                        value={selectedParent}
                        onChange={onParentChange}
                    />
                </Div>
                {mode === 'update' && (
                    <Div className="d-flex justify-content-end">
                    <ConfirmButton
                        title="Remove parent company"
                        message={
                            <>
                                Are you sure you want to remove <strong>{company.parentCompanyName}</strong> as parent of <strong>{company.legalName}</strong>? This action cannot be undone.
                            </>
                        }
                        confirmLabel="Remove"
                        cancelLabel="Cancel"
                        showCancelButton
                        onConfirm={onRemove}
                        label="Remove parent"
                        variant="button"
                        buttonVariant="danger"
                        confirmVariant="danger"
                    />
                    </Div>
                )}
        </ConfirmationModal>
    );
};

export default AddUpdateParentModal;

